import { render, staticRenderFns } from "./TableauIdentities.vue?vue&type=template&id=faffc844&scoped=true&"
import script from "./TableauIdentities.vue?vue&type=script&lang=js&"
export * from "./TableauIdentities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faffc844",
  null
  
)

export default component.exports